import React, { Component } from 'react';
import AlgoDropdown from './AlgoDropdown.js';
import FMGraphicalOperators from './fm/FMGraphicalOperators.js';
import {setParameterSliderDown} from "actions/index.js";
import {updateParameter} from 'operations/actions.js';
import { connect } from "react-redux";
import EffectParameterSlider from 'components/effects/EffectParameterSlider.js';
import { Text, Circle, Group, Stage, Layer, Rect, Line} from 'react-konva';

const MOD_MAX = 15;

window.fmColor = '#0c3545';
window.fmGuideColor = '#66d6ff';
window.selectedFMColor = '#86fcf7';

const WIDTH=242;
const HEIGHT=140;
const INNER_HEIGHT= 136;

const HARMONICITIES = [2, 4, 6, 8, 10, 12, 14, 16, 18];
const MODULATION_INDICES = [1, 10, 20, 60, 120, 240, 480, 800, 900];

class FMHarmonicityModulation extends Component {

    constructor(props) {
        super(props);

        this.state = {
            dragging: false,
        };

        this.ref = React.createRef();

        this.innerHeight = this.props.innerHeight || INNER_HEIGHT;
        this.height = this.props.innerHeight || HEIGHT;
        
    }

    set draggingOsc(osc) {
        this.dragging = osc;

        if (osc) {
            this.props.setSelectedOsc(osc);
        }
    }

    updateParameter(parameter, value) {
        this.props.sequencerEngine.operationManager.dispatch(
            updateParameter(
                parameter,
                value));
    }

    set harmonicity(h) {
        let osc = this.props.oscillator;
        if (osc && osc.harmonicityParameter.get(true) !== h) {
            this.updateParameter(
                osc.harmonicityParameter,
                h);
        }
    }

    set modulationIndex(m) {
        let osc = this.props.oscillator;
        if (osc && osc.modulationIndexParameter.get(true) !== m) {
            this.updateParameter(
                osc.modulationIndexParameter,
                m);
        }
    }

    get harmonicity() {
        return this.props.harmonicity;
    }

    get modulationIndex() {
        return this.props.modulationIndex;
    }

    getHarmonicityXPosition(harmonicity) {
        return (harmonicity / 20) * WIDTH;
    }

    getHarmonicityX(osc) {
        return this.getHarmonicityXPosition(osc.harmonicityParameter.get());
    }

    getModulationIndexYPosition(modulationIndex) {
        return this.innerHeight - ((Math.sqrt(modulationIndex) / MOD_MAX) * this.innerHeight);
    }

    getModulationIndexY(osc) {
        return this.getModulationIndexYPosition(osc.modulationIndexParameter.get());
    }

    getHelperLines() {
        let osc = this.props.oscillator;
        if (!this.props.oscillator) {
            return [];
        }
        return [
            <line x1={this.getHarmonicityX(osc)} y1={0} x2={this.getHarmonicityX(osc)} y2={this.innerHeight} strokeWidth={1} stroke={window.fmGuideColor}/>,
            <line x1={0} y1={this.getModulationIndexY(osc)} x2={WIDTH}
                  y2={this.getModulationIndexY(osc)} strokeWidth={1} stroke={window.fmGuideColor}/>,
        ];
    }

    getHarmonicityLines() {
        return HARMONICITIES.map(
            (harmonicity, i) => 
                <line
                  key={i}
                  className="fm-guide-line"
                  x1={this.getHarmonicityXPosition(harmonicity)}
                  y1={0}
                  x2={this.getHarmonicityXPosition(harmonicity)}
                  y2={this.innerHeight}
                  strokeWidth={1}
                  stroke={window.fmColor}/>);
    }

    getModulationIndexLines() {
        return MODULATION_INDICES.map(
            (modIndex, i) => 
                <line
                  key={i}
                  className="fm-guide-line"
                  x1={0}
                  y1={this.getModulationIndexYPosition(modIndex)}
                  x2={WIDTH}
                  y2={this.getModulationIndexYPosition(modIndex)}
                  strokeWidth={1}
                  stroke={window.fmColor}/>);
    }

    convertXY(x, y) {
        let el = this.ref.current;
        let rect = el.getBoundingClientRect();
        return [x - rect.left, y - rect.top];
    }

    onMouseMove(e) {
        if (!this.dragging) {
            return;
        }

        let [x, y] = this.convertXY(e.clientX, e.clientY);
        this.setXAndY(x, y);
    }

    setXAndY(x, y) {
        let harmonicity = Math.floor((20.0 * x / WIDTH) * 1000) / 1000;
        this.harmonicity = Math.round(harmonicity * 4) / 4;
        this.modulationIndex = Math.pow(
            Math.max(
                0,
                Math.floor(1000 * MOD_MAX  * (this.innerHeight - y) / this.innerHeight) / 1000),
            2);
    }

    render() {
        let selectedOsc = this.props.oscillator;
        let oscs = this.props.instrument.oscillators;
        if (oscs === undefined) {
            return [];
        }

        return (
            <div>
              <AlgoDropdown
                onChange={this.props.onChangeAlgorithm}
                instrument={this.props.instrument}/>
              <svg
                ref={this.ref}
                id={"harmonicity-mod-" + this.props.instrument.id}
                className="harmonicity-mod"
                onMouseMove={(e) => this.onMouseMove(e)}
                onClick={(e) => this.setXAndY(... this.convertXY(e.clientX, e.clientY))}
                onMouseLeave={(e) => this.draggingOsc = undefined}
                width={WIDTH} height={this.innerHeight}>
                  <rect width={WIDTH} height={this.innerHeight} fill={this.props.backgroundColor || 'black'}/>
                  {this.getHarmonicityLines()}
                  {this.getModulationIndexLines()}
                {oscs.map(
                    (osc, i) =>
                    <FMGraphicalOperators
                      key={i}
                      color={this.props.color}
                      height={this.height}
                      innerHeight={this.innerHeight}
                      osc={osc}
                      setDraggingOsc={(osc) => this.draggingOsc = osc}
                      dragging={this.dragging}
                      setSelectedOsc={this.props.setSelectedOsc}
                      instrument={this.props.instrument}
                      oscillator={this.props.oscillator}/>
                )}
               </svg>
            </div>
        );
    }
}

const mapDispatchToProps = dispatch => {
    return {
        setParameterSliderDown: parameter => dispatch(setParameterSliderDown(parameter)),
    };
};
 

export default connect(null, mapDispatchToProps)(FMHarmonicityModulation);

